import { Injectable, OnDestroy } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { BehaviorSubject, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomHamburgerMenuService implements OnDestroy {
  isExpanded: BehaviorSubject<boolean> = new BehaviorSubject(false);

  private subscription = new Subscription();

  constructor(router: Router) {
    this.subscription.add(
      router.events
        .pipe(
          filter((event) => event instanceof NavigationStart),
          filter((event: NavigationStart) => event.url.split('?')[0] !== router.url.split('?')[0]),
        )
        .subscribe(() => {
          this.toggle(true);
        }),
    );
  }

  /**
   * toggles the expand state of the hamburger menu
   */
  toggle(forceCollapse?: boolean): void {
    if (forceCollapse) {
      this.isExpanded.next(false);
    } else {
      this.isExpanded.next(!this.isExpanded.value);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
